<template>
  <div>
    <DialogBase
      v-model="inputedValue.dialog"
      :title="title"
      :width="width"
      isPadding0="true"
    >
      <v-card class="content">
        <v-row>
          <v-col>
            <v-list dense>
              <v-list-item-group
                v-model="selectedShortcutItem"
                color="primary"
                class="list"
              >
                <v-list-item v-for="(item, i) in shortcutItems" :key="i">
                  <v-list-item-content>
                    <v-list-item-title v-text="item.text"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-col>
          <v-col class="commands">
            <div>
              <NormalButton
                :text="'＜' + $t('common.common_common_addition')"
                height="32px"
                width="70px"
                color="white"
                textColor="thinText--text"
                :outlined="true"
                @click="addItem"
                :disabled="
                  typeof selectedCandidateItem == 'undefined' ||
                  shortcutMaxLength <= shortcutItems.length
                "
              />
              <br />
              <NormalButton
                text="削除 ＞"
                height="32px"
                width="70px"
                color="white"
                textColor="thinText--text"
                :outlined="true"
                @click="removeItem"
                :disabled="typeof selectedShortcutItem == 'undefined'"
              />
            </div>
          </v-col>
          <v-col>
            <v-list dense>
              <v-list-item-group
                v-model="selectedCandidateItem"
                color="primary"
                class="list"
              >
                <template v-for="(item, i) in candidateItems">
                  <v-list-item
                    v-show="item.isShow"
                    :key="i"
                    :disabled="item.isDisabled"
                    v-bind:class="{
                      disabled: item.isDisabled
                    }"
                  >
                    <v-list-item-content>
                      <v-list-item-title v-text="item.text"></v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-list-item-group>
            </v-list>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="annotation">
            {{
              $t('common.common_up-to-number-can-be-set-first-half') +
              shortcutMaxLength +
              $t('common.common_up-to-number-can-be-set-first-half')
            }}
          </v-col>
        </v-row>
        <v-row>
          <v-col class="buttons">
            <v-btn
              @click="close"
              width="130px"
              height="50px"
              class="btnStyle button ml-2 mr-4"
            >
              {{ $t('user.user_cancel') }}
            </v-btn>
            <NormalButton
              class="btnStyle button ml-2 mr-4"
              btnClass="pa-0"
              :text="$t('common.input_save')"
              width="130px"
              height="50px"
              textSize="16px"
              @click="save"
            />
          </v-col>
        </v-row>
      </v-card>
    </DialogBase>
  </div>
</template>
<script>
import DialogBase from './DialogBase'
import NormalButton from '@/components/items/Buttons/NormalButton'
import { viewConfig } from '@/config'
import { mapActions, mapGetters } from 'vuex'
import { OFTEN_SCREEN_INFO } from '@/config/master/screenId'

export default {
  components: {
    DialogBase,
    NormalButton
  },
  props: {
    value: {
      dialog: false
    },
    width: { default: '650px' },
    title: { default: '' }
  },
  data: () => ({
    shortcutMaxLength: viewConfig.SHORTCUT_MAX_LENGTH,
    oftenUseScreenList: [],
    selectedShortcutItem: undefined,
    selectedCandidateItem: undefined,
    shortcutItems: [],
    candidateItems: []
  }),
  created() {
    this.oftenUseScreenList = this.getOftenUseScreenListFromState()
  },
  methods: {
    ...mapActions('OftenUse', ['getOftenUseListFromApi', 'editOftenUse']),
    ...mapGetters('OftenUse', ['getOftenUseListFromState']),
    ...mapGetters('Common', ['getOftenUseScreenListFromState']),
    init() {
      const oftenUseList = this.getOftenUseListFromState()

      // ショートカット一覧
      this.shortcutItems = oftenUseList.map((oftenUseItem) => {
        return {
          oftenUseScreenId: oftenUseItem.oftenUseScreenId,
          text: this.$t(OFTEN_SCREEN_INFO[oftenUseItem.oftenUseScreenId].name),
          index: this.getOftenUseItemIndex(oftenUseItem.oftenUseScreenId)
        }
      })

      // 選択肢一覧
      this.candidateItems = this.oftenUseScreenList.map(
        (oftenUseScreenItem) => {
          return {
            oftenUseScreenId: oftenUseScreenItem.oftenUseScreenId,
            text: this.$t(
              OFTEN_SCREEN_INFO[oftenUseScreenItem.oftenUseScreenId].name
            ),
            link: OFTEN_SCREEN_INFO[oftenUseScreenItem.oftenUseScreenId].link,
            isDisabled: this.isAddedShortcutItems(oftenUseScreenItem),
            isShow: this.isShowItems(oftenUseScreenItem)
          }
        }
      )
    },
    addItem() {
      this.shortcutItems.push({
        ...this.candidateItems[this.selectedCandidateItem],
        index: this.selectedCandidateItem
      })
      this.candidateItems[this.selectedCandidateItem].isDisabled = true
      this.selectedCandidateItem = undefined
    },
    removeItem() {
      var index = this.shortcutItems[this.selectedShortcutItem].index
      this.candidateItems[index].isDisabled = false
      this.shortcutItems.splice(this.selectedShortcutItem, 1)
    },
    async save() {
      const editResponse = await this.editOftenUse(this.shortcutItemsRequest)
      if (!editResponse) return
      const getResponse = await this.getOftenUseListFromApi()
      if (!getResponse) return
      this.close()
    },
    close() {
      this.inputedValue.dialog = false
    },
    getOftenUseItemIndex(oftenUseScreenId) {
      return this.oftenUseScreenList.findIndex((oftenUseScreenItem) => {
        return oftenUseScreenItem.oftenUseScreenId === oftenUseScreenId
      })
    },
    isAddedShortcutItems(oftenUseScreenItem) {
      return this.shortcutItems.some(
        (shortcutItem) =>
          shortcutItem.oftenUseScreenId === oftenUseScreenItem.oftenUseScreenId
      )
    },
    isShowItems(oftenUseScreenItem) {
      // アクセス権限があるrouteの場合は権限チェックを行う
      const targetRoute = this.$router.options.routes.find(
        (route) =>
          route.name ===
          OFTEN_SCREEN_INFO[oftenUseScreenItem.oftenUseScreenId].link
      )
      if (targetRoute?.meta?.permissions) {
        return targetRoute.meta.permissions.includes(this.authority.id)
      }
      return true
    }
  },
  watch: {
    inputedValue: {
      deep: true,
      async handler(newVal) {
        if (!newVal.dialog) return
        this.init()
      }
    }
  },
  computed: {
    ...mapGetters('User', ['authority']),
    inputedValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    },
    shortcutItemsRequest() {
      const oftenUseList = this.shortcutItems.map((item, index) => {
        return {
          oftenUseScreenId: item.oftenUseScreenId,
          sortNumber: index + 1
        }
      })
      return { oftenUseList }
    }
  }
}
</script>
<style lang="scss" scoped>
.content {
  overflow: hidden;
  padding: 30px !important;
}
.list {
  overflow-y: auto;
  padding: 0;
  min-width: 210px;
  max-width: 210px;
  min-height: 200px;
  max-height: 200px;
  border: solid 1px #c8cfd7;
  border-radius: 4px;
}
.disabled {
  color: #999999;
  background-color: #f3f3f3;
}
.v-list-item {
  font-size: 14px;
  min-height: 32px;
}
.v-list-item--active {
  color: #ffffff;
  background-color: #004e88;
}
.commands {
  display: table;
}
.commands > div {
  display: table-cell;
  text-align: center;
  vertical-align: middle;
}
.buttons {
  text-align: right;
  padding-right: 0;
}
.button {
  display: inline;
  font-size: 16px;
}
.annotation {
  color: #999999;
  font-size: 13px;
  padding-top: 0px;
}
</style>
